import {
  useIsDesktop,
  useIsXSOrSmaller,
  useIsiOS,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {View} from 'native-base';
import React from 'react';
import {Platform} from 'react-native';

import MaskTitle from 'components/SecurityMask/MaskTitle';
import MirroredGradient from 'components/SecurityMask/MirroredGradient';

import {GatedModulePropTypes} from '..';
import GatedProfilePanel from '../GatedProfilePanel';
import {useTheme} from 'styled-components/native';
import SecurityMask from 'components/SecurityMask';

const GatedSecurityInfoModule: React.FC<GatedModulePropTypes> = ({
  mfaOptinStatus,
  onPrimaryPress,
  isLoading,
}) => {
  const isDesktop = useIsDesktop();
  const isXSOrSmaller = useIsXSOrSmaller();
  const isiOS = useIsiOS();
  const theme = useTheme();
  const {athens} = theme.colors;

  return (
    <GatedProfilePanel
      isLoading={isLoading}
      panelTitle="Two-Step Verification"
      iconName="shield-alt"
      onPrimaryPress={onPrimaryPress}
      mfaOptinStatus={mfaOptinStatus}
      testID="security-info">
      <View
        borderColor="#DCDCDC"
        borderWidth="2px"
        borderStyle="solid"
        borderRadius="8px"
        flexDirection="row"
        padding="24px"
        alignItems="center"
        overflow="hidden">
        <View flexDirection="column" minW={isXSOrSmaller ? '100px' : '160px'}>
          <SecurityMask title="verified contact" showAsterisk />
        </View>
      </View>
    </GatedProfilePanel>
  );
};

export default GatedSecurityInfoModule;
